(function() { window.GUID_f70e19d0_5975_4392_89d2_a3dd9380521d = { getGuid: function() { return "f70e19d0-5975-4392-89d2-a3dd9380521d"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class OpponentDetails extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                CS.Helper.log("OpponentDetails", "Instantiating OpponentDetails control");
                this.controlId = params[0];
            }
            OnBindEvents() {
                this.$Control.offon("click.OpponentDetailsActionClick", `.action`, this.handleActionClick.bind(this));
            }
            OnDispose() { }
            OnControlRendered() { }
            handleActionClick(e) {
                const $action = $(e.currentTarget);
                const url = $action.data("url");
                if (!CS.Helper.isNullOrWhiteSpace(url)) {
                    return CS.Nav.Go(url);
                }
                const action = $action.data("action");
                if (CS.Helper.isNullOrWhiteSpace(action)) {
                    return;
                }
                switch (action) {
                    case "favorite":
                        return this.handleFavoriteClick($action);
                    case "follow":
                        return this.handleFollowClick($action);
                    default:
                        return;
                }
            }
            handleFavoriteClick($action) {
                const $favoriteButton = $action.find(".cs-favorite-button");
                if (!$favoriteButton.length) {
                    return;
                }
                const searchType = $favoriteButton.data("type");
                const id = $favoriteButton.data("id");
                CS.Views.ViewBase.toggleFavorite($favoriteButton, (isFavorite) => {
                    // TODO: If isFavorite, remove favorite class on all items
                    const $items = $(`.cs-favorite-button[data-id="${id}"]`);
                    if (!$items.length) {
                        return;
                    }
                    $items.each((index, item) => {
                        const $item = $(item);
                        if (isFavorite) {
                            $item.addClass("is-favorite");
                        }
                        else {
                            $item.removeClass("is-favorite");
                        }
                    });
                });
                this.closeParentPopup();
            }
            handleFollowClick($action) {
                const $hiddenInput = this.$Control.find(`#${this.ControlId}-NotificationsModalUrl`);
                if (!$hiddenInput.length) {
                    return;
                }
                const url = $hiddenInput.val();
                if (CS.Helper.isNullOrWhiteSpace(url)) {
                    return;
                }
                CS.Controls.Popup.ShowAjaxModal(url, null, ({ popup, isPopup }) => {
                    if (isPopup) {
                        const $toolbarButtons = popup.$Control.find(".friend-toolbar-button");
                        if ($toolbarButtons.length) {
                            $toolbarButtons.hide();
                        }
                    }
                }, () => {
                    this.closeParentPopup();
                }, true);
            }
            closeParentPopup() {
                const $parentPopup = this.$Control.closest(".popup.control-cs");
                if (!$parentPopup.length) {
                    return;
                }
                const popup = Controls.GetInstance(Controls.Popup, $parentPopup, true);
                if (!popup) {
                    return;
                }
                popup.Close();
            }
        }
        Controls.OpponentDetails = OpponentDetails;
        //export namespace OpponentDetails {
        //    export class Events {
        //        public static PersonaItemClicked(
        //            param: IEvent<PersonaPicker, PersonaPickerItemClickedData>
        //        ) {
        //            RegisterEvent(PersonaPicker, EventNames.PersonaItemClicked, param);
        //        }
        //    }
        //    export class EventNames {
        //        public static PersonaItemClicked: string = "persona-item-clicked";
        //    }
        //}
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=opponent-details.js.map
